import type { ProductDataDTO } from "~/dto/ProductDataDTO";
import DataSheetDownload from "./components/DataSheetDownload";
import { transformProduct } from "~/ProductDetails/transformers/ProductDataTransformer";

export const createDataSheetPage = ({ product }: { product: string }) => {
  const dto = JSON.parse(product) as ProductDataDTO;
  return <DataSheetDownload product={transformProduct(dto)} />;
};
